var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFasttagRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_6683)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_46_6683)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85 3.94768V7.74767H6.26C4.19 7.74767 2.5 9.43768 2.5 11.5077V7.8377C2.5 6.6477 3.23 5.58765 4.34 5.16765L12.28 2.16765C13.52 1.70765 14.85 2.61768 14.85 3.94768Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.56 13.9731V16.0331C22.56 16.5831 22.12 17.0331 21.56 17.0531H19.6C18.52 17.0531 17.53 16.2631 17.44 15.1831C17.38 14.5531 17.62 13.9631 18.04 13.5531C18.41 13.1731 18.92 12.9531 19.48 12.9531H21.56C22.12 12.9731 22.56 13.4231 22.56 13.9731Z",
    fill: "#347D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z",
    fill: "#347D73"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_6683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_46_6683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasttagRevenue);
export default __webpack_public_path__ + "static/media/fasttag-revenue.7e911752810c423066bed711bd958d64.svg";
export { ForwardRef as ReactComponent };